import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UncontrolledTooltip } from "reactstrap";

import * as authRoutines from "modules/Auth/routines";
import { Loader, Preloader } from "components";
import LogoIcon from "assets/images/logo.png";

import QuickCreateDropdown from "./QuickCreateDropdown";
import LanguageDropdown from "./LanguageDropdown";

const TRANSLATION_BASE = "quickCreate";

const Topbar = ({ menuToggle }) => {
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { session } = useSelector(state => state.Auth);

  const QuickCreations = [
    { title: t(`${TRANSLATION_BASE}.create_admins`), icon: "fe-shield", link: "admin" },
    { title: t(`${TRANSLATION_BASE}.create_teachers`), icon: "mdi mdi-teach", link: "teacher" },
    { title: t(`${TRANSLATION_BASE}.create_categories`), icon: "fe-copy", link: "category" },
    { title: t(`${TRANSLATION_BASE}.create_courses`), icon: "fe-book", link: "/dashboard/course/create", page: true }
  ];

  const handleOnLogout = () => {

    setLoading(true);

    const onSuccess = () => {
      setLoading(false);
    };
    const onError = () => {
      setLoading(false);
    };

    dispatch(
      authRoutines.logout({
        values: { session_id: session?.id }
      })
    );
  };

  return (
    <React.Fragment>
      <div className="navbar-custom" style={{ background: "#3c8ff9 !important" }}>
        <ul className="list-unstyled topnav-menu float-right mb-0">
          <li>
            <LanguageDropdown />
          </li>
          <li>
            <Preloader loading={loading}>
              <div
                id="logout"
                className="btn btn-link nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light"
                onClick={handleOnLogout}>
                <i className="mdi mdi-logout" style={{ fontSize: 20 }} />
              </div>
            </Preloader>
            <UncontrolledTooltip target="logout">{t("modules.auth.logout")}</UncontrolledTooltip>
          </li>
        </ul>

        <div className="logo-box">
          <Link
            to="/"
            className="logo text-center"
            style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <h3 style={{ textTransform: "uppercase", color: "white", fontWeight: "bold", margin: "auto" }}>
              {/* Суд Экспертиза */}
              <img src={LogoIcon} style={{ width:50 }} />
            </h3>
          </Link>
        </div>

        <ul className="list-unstyled topnav-menu topnav-menu-left m-0">
          <li>
            <button className="button-menu-mobile waves-effect waves-light" onClick={menuToggle}>
              <i className="fe-menu"></i>
            </button>
          </li>

          <li className="dropdown d-none d-lg-block">
            <QuickCreateDropdown quickCreations={QuickCreations} />
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};

export default Topbar;
